#import "../fragments/cta-banner-fragment.graphql"

query GetCTABanners {
    ctaBanners {
        ...CTABanner
    }
}
